"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintTaskResponse = exports.PrintTaskFailedResponse = exports.PrintTaskProgressResponse = exports.PrintTaskCompleteResponse = exports.PrintTaskRequest = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../ResponseBase");
const RemoteFile_1 = require("./RemoteFile");
class PrintTaskRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, tslib_1.__metadata)("design:type", String)
], PrintTaskRequest.prototype, "taskId", void 0);
exports.PrintTaskRequest = PrintTaskRequest;
class PrintTaskCompleteResponse extends ResponseBase_1.ResponseBase {
    constructor() {
        super(...arguments);
        this.status = 'COMPLETE';
    }
}
PrintTaskCompleteResponse.status = 'COMPLETE';
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", Object)
], PrintTaskCompleteResponse.prototype, "status", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsInstance)(RemoteFile_1.TemporaryRemoteFile),
    (0, tslib_1.__metadata)("design:type", RemoteFile_1.TemporaryRemoteFile)
], PrintTaskCompleteResponse.prototype, "pdf", void 0);
exports.PrintTaskCompleteResponse = PrintTaskCompleteResponse;
class PrintTaskProgressResponse extends ResponseBase_1.ResponseBase {
    constructor() {
        super(...arguments);
        this.status = 'IN_PROGRESS';
    }
}
PrintTaskProgressResponse.status = 'IN_PROGRESS';
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", Object)
], PrintTaskProgressResponse.prototype, "status", void 0);
exports.PrintTaskProgressResponse = PrintTaskProgressResponse;
class PrintTaskFailedResponse extends ResponseBase_1.ResponseBase {
    constructor() {
        super(...arguments);
        this.status = 'FAILED';
    }
}
PrintTaskFailedResponse.status = 'FAILED';
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", Object)
], PrintTaskFailedResponse.prototype, "status", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], PrintTaskFailedResponse.prototype, "failureMessage", void 0);
exports.PrintTaskFailedResponse = PrintTaskFailedResponse;
class PrintTaskResponse extends designed_1.Entity.Union.define({
    key: 'status',
    entries: [
        PrintTaskCompleteResponse,
        PrintTaskProgressResponse,
        PrintTaskFailedResponse,
    ],
}) {
}
exports.PrintTaskResponse = PrintTaskResponse;
